import AccountDashboardButtons from "./AccountDashboardButtons";
import React from "react";

export const AccountDashboardButtonsWrapper = props => (
  <div className="aCbuttonsWrapper do-not-close-minicashier-drawer">
    <AccountDashboardButtons {...props} />
  </div>
);
